import { Alert, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import type { ConsentSelection } from '../legalConfig';

type OptionalConsentsSectionProps = {
  value: ConsentSelection;
  onChange: (nextValue: ConsentSelection) => void;
  showSpecialCategoryConsent?: boolean;
  showPreferenceConsents?: boolean;
  showTitle?: boolean;
};

export default function OptionalConsentsSection({
  value,
  onChange,
  showSpecialCategoryConsent = false,
  showPreferenceConsents = true,
  showTitle = true,
}: OptionalConsentsSectionProps) {
  if (!showPreferenceConsents && !showSpecialCategoryConsent) {
    return null;
  }

  return (
    <Stack spacing={1.5}>
      {showTitle ? (
        <Typography variant="subtitle1" fontWeight={700}>
          Choix optionnels et specifiques
        </Typography>
      ) : null}

      {showPreferenceConsents ? (
        <>
          <FormControlLabel
            control={
              <Checkbox
                checked={value.marketingEmailAccepted}
                onChange={(event) => onChange({ ...value, marketingEmailAccepted: event.target.checked })}
              />
            }
            label="J'accepte de recevoir des emails d'actualité, de nouvelles dates et d'offres Jacana Nature."
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={value.analyticsCookiesAccepted}
                onChange={(event) => onChange({ ...value, analyticsCookiesAccepted: event.target.checked })}
              />
            }
            label="J'autorise la mesure d'audience et l'analyse de navigation pour améliorer le site."
          />
        </>
      ) : null}

      {showSpecialCategoryConsent ? (
        <>
          <Alert severity="warning" variant="outlined">
            Vous avez renseigné des informations pouvant révéler des données de santé ou d'allergies. Leur traitement doit être explicitement autorisé.
          </Alert>
          <FormControlLabel
            control={
              <Checkbox
                checked={value.specialCategoryDataAccepted}
                onChange={(event) => onChange({ ...value, specialCategoryDataAccepted: event.target.checked })}
              />
            }
            label="J'autorise Jacana Nature à traiter ces informations uniquement pour organiser la sortie et prendre en compte mes besoins particuliers."
          />
        </>
      ) : null}
    </Stack>
  );
}